import { scrollToId } from "@/lib/scroll";
import { Reveal, SectionHead } from "./Reveal";

const services = [
  {
    num: "01",
    label: "The Entry",
    name: "Exterior Care",
    price: "From $89",
    desc: "A refined exterior maintenance service for vehicles that need a clean, presentable finish without a full restoration.",
    features: ["Hand wash", "Wheels and tires", "Exterior glass", "Finishing touch", "Light exterior protection"],
    cta: "Request Service",
    interest: "THE ENTRY",
    featured: false,
    testid: "service-entry",
  },
  {
    num: "02",
    label: "The Within",
    name: "Interior Restoration",
    price: "From $159",
    desc: "A deeper interior service designed to restore order, cleanliness, and presentation inside the vehicle.",
    features: ["Deep vacuum", "Interior surfaces", "Touch points", "Interior glass", "Light spot treatment", "Condition assessment"],
    cta: "Request Service",
    interest: "THE WITHIN",
    featured: false,
    testid: "service-within",
  },
  {
    num: "03",
    label: "The Standard",
    name: "Complete Vehicle Reset",
    price: "From $249",
    desc: "The complete DARK reset for vehicles that need interior and exterior attention before ongoing maintenance.",
    features: ["Interior restoration", "Exterior care", "Condition assessment", "Tailored recommendations"],
    note: "Membership eligibility may begin here.",
    cta: "Request The Standard",
    interest: "THE STANDARD",
    featured: true,
    testid: "service-standard",
  },
];

export const Services = ({ onSelect }) => (
  <section id="services" data-testid="services-section" className="py-28 sm:py-40 px-5 sm:px-8">
    <div className="max-w-7xl mx-auto">
      <SectionHead
        index="01"
        overline="Services"
        title="Choose the level of care."
        copy="Not every vehicle needs the same level of care."
      />
      <div className="grid lg:grid-cols-3 mt-20 border-t border-graphite">
        {services.map((s, i) => (
          <Reveal key={s.num} delay={i * 0.1} className="h-full">
            <article
              data-testid={s.testid}
              className={`h-full flex flex-col px-2 sm:px-8 py-12 sm:py-14 lg:border-l lg:border-graphite first:border-l-0 ${
                s.featured ? "bg-onyx/60" : ""
              }`}
            >
              <div className="flex items-baseline justify-between">
                <span className="font-accent text-[10px] tracking-[0.35em] uppercase text-volt">{s.label}</span>
                <span className="font-display text-silver/40 text-lg">{s.num}</span>
              </div>
              <h3 className="font-display text-3xl sm:text-4xl text-ivory mt-6 leading-tight">{s.name}</h3>
              <p className="font-display text-xl metallic-text mt-4" data-testid={`${s.testid}-price`}>{s.price}</p>
              <p className="text-silver/70 text-sm leading-relaxed mt-5">{s.desc}</p>
              <ul className="mt-8 flex-1">
                {s.features.map((f) => (
                  <li key={f} className="text-sm text-silver/80 py-2.5 border-t border-graphite/60 first:border-t-0">
                    {f}
                  </li>
                ))}
              </ul>
              {s.note && (
                <p className="font-accent text-[10px] tracking-[0.25em] uppercase text-volt/90 mt-2 mb-1">{s.note}</p>
              )}
              <button
                data-testid={`${s.testid}-cta`}
                onClick={() => { onSelect?.(s.interest); scrollToId("request"); }}
                className={`mt-7 self-start font-accent text-xs tracking-[0.25em] uppercase px-8 py-4 transition-colors duration-300 ${
                  s.featured
                    ? "cta-shadow bg-volt text-white hover:bg-[#4A8FFF]"
                    : "border border-silver/25 text-silver hover:border-volt hover:text-ivory"
                }`}
              >
                {s.cta}
              </button>
            </article>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.15}>
        <p className="mt-8 max-w-2xl text-xs text-silver/50 leading-relaxed">
          Starting prices vary by vehicle size and condition. If your vehicle requires more than the starting scope, we confirm the price with you before work begins.
        </p>
      </Reveal>
    </div>
  </section>
);
